<template>
    <p>in developing</p>
</template>
<script>
import router from '@/router';
import {getState} from '@/hub/auth';
export default {
  name: 'TrackerPage',
  props: {
    msg: String
  },
  data(){
    return{
      email: null,
      token: null,
      state: null
    };
  },
  methods: {
    goToHub(){
      router.push({name: 'hub'})
    }
  },
  async created(){
    this.token = localStorage.getItem('ArgoToken')
    if(this.token){
      this.email = localStorage.getItem('ArgoUserEmail')
      this.state = await getState(this.email, this.token)
      if(!this.state){
        router.push({name: 'login'})
      }
    }
    else{
      router.push({name: 'login'})
    }
    
  }
}
</script>